import Vue from 'vue';
import axios from 'axios';
import { getHospital } from '@/services/inst.service';

/**
 * 医保（EasyHis）连接状态
 * - unknown：尚未探测（初始态，业务调用放行）
 * - online ：最近一次探活/业务调用成功
 * - offline：最近一次探活/业务调用网络失败
 */
const state = Vue.observable({
    status: 'unknown'
});

const HEARTBEAT_INTERVAL_MS = 3 * 60 * 1000;
const PING_TIMEOUT_MS = 2000;

let timer = null;

export function getHisStatus() {
    return state;
}

export function setHisStatus(next) {
    if (state.status !== next) {
        state.status = next;
    }
}

/**
 * 探活：调 EasyHis 的 GET /inst/info（无副作用、纯本地配置读取）
 * 用独立 axios 实例，绕开 hisrequest 拦截器，避免递归
 */
export async function pingHis() {
    const hospital = getHospital();
    if (!hospital || !hospital.hisLocalServiceUrl) {
        setHisStatus('offline');
        return false;
    }
    const baseURL = hospital.hisLocalServiceUrl.replace(/\/+$/, '');
    try {
        await axios.get(`${baseURL}/inst/info`, { timeout: PING_TIMEOUT_MS });
        setHisStatus('online');
        return true;
    } catch (e) {
        setHisStatus('offline');
        return false;
    }
}

/** 启动心跳：立即探一次 + 每 3 分钟探一次 */
export function startHisHeartbeat() {
    stopHisHeartbeat();
    pingHis();
    timer = setInterval(pingHis, HEARTBEAT_INTERVAL_MS);
}

export function stopHisHeartbeat() {
    if (timer) {
        clearInterval(timer);
        timer = null;
    }
}
